import React from 'react';

const JS_Math = () => {
  return (
    <div >
      <h1>JS_Math</h1>
      <p>Placeholder component for: "JS Math"</p>
    </div>
  );
};

export default JS_Math;
